import { render, staticRenderFns } from "./quisommesnous.vue?vue&type=template&id=20cc01fa&"
import script from "./quisommesnous.vue?vue&type=script&lang=js&"
export * from "./quisommesnous.vue?vue&type=script&lang=js&"
import style0 from "./quisommesnous.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports